// Монограмма категории: первая буква названия в круге с тинтом по slug.
// Заменяет эмодзи категорий во всём UI (эмодзи из БД остаётся для бота).

import { categoryTintIndex } from '../lib/colors';

type Props = {
  name: string | null | undefined;
  slug?: string | null;
  size?: 'sm' | 'md';
};

export function CategoryMark({ name, slug, size = 'md' }: Props): JSX.Element {
  const trimmed = (name ?? '').trim();
  const letter = trimmed ? trimmed.charAt(0).toUpperCase() : '·';
  const tint = categoryTintIndex(slug ?? trimmed);
  return (
    <span className={`catmark catmark-${size} tint-${tint}`} aria-hidden="true">
      {letter}
    </span>
  );
}
